module.exports = __webpack_public_path__ + "img/icn_stickers.8c1b3b72.svg";